export default __webpack_public_path__ + "static/media/DITTO-BNB.496ed35b.svg";